document.addEventListener("DOMContentLoaded", async function () {
  try {
    await window.loadSwiper();
  } catch (error) {
    console.error('[tab-cards] Unable to load Swiper.', error);
    return;
  }

  (function () {
    let swiperInstance1 = null, swiperInstance2 = null;
    let currentIndex = 0;
    let autoSwitchTimer = null;

    function resetProgressBars(selector) {
      document.querySelectorAll(`${selector} .progress-bar`).forEach((bar) => {
        bar.style.width = "0%";
        bar.style.transition = "none";
      });
      document.querySelectorAll(`${selector} .progress-slide`).forEach((p_slide) => {
        p_slide.style.color = "#999999";
      });
    }

    function changeTab(index, selector, swiperInstance) {
      if (!document.querySelector(selector) || !swiperInstance) return; // 避免 PC 或手机端不存在 Swiper 时出错

      clearInterval(autoSwitchTimer);
      currentIndex = index;

      descriptionElements.forEach((item) => item.classList.remove("block"));
      descriptionElements[index].classList.add("block");
      videoElements.forEach((item) => item.classList.remove("block"));
      videoElements[index].classList.add("block");

      document.querySelectorAll(`${selector} .progress-container`).forEach((bar) => {
        bar.classList.remove("active");
      });

      resetProgressBars(selector);

      let activeProgressContainer = document.querySelector(
        `${selector} .swiper-slide:nth-child(${index + 1}) .progress-container`
      );
      if (activeProgressContainer) {
        activeProgressContainer.classList.add("active");
      }

      let activeProgress = document.querySelector(
        `${selector} .swiper-slide:nth-child(${index + 1}) .progress-bar`
      );
      if (activeProgress) {
        setTimeout(() => {
          activeProgress.style.transition = `width ${swiperTime}ms linear`;
          activeProgress.style.width = "100%";
          activeProgress.style.background = activeLineColor;
        }, 10);
      }

    document.querySelectorAll(`${selector} .progress-slide`).forEach((slide) => {
      slide.classList.remove("progress-active");
    });

    let activeProgressSlide = document.querySelector(
      `${selector} .swiper-slide:nth-child(${index + 1}) .progress-slide`
    );
    if (activeProgressSlide) {
      activeProgressSlide.classList.add("progress-active");
    }


      document.querySelector(
        `${selector} .swiper-slide:nth-child(${index + 1}) .progress-slid`
      );

      swiperInstance.slideTo(index);
      startAutoSwitching();
    }

    function initSwiper(selector) {
      if (!document.querySelector(selector)) return null; // 如果该 swiper 不存在，直接返回 null，防止报错
      return new Swiper(selector, {
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: false,
        slideToClickedSlide: true,
        autoplay: false,
        on: {
          init: function (swiper) {
            changeTab(0, selector, swiper);
          },
          click: function (swiper) {
            let index = swiper.clickedIndex;
            if (typeof index !== "undefined") {
              changeTab(index, selector, swiper);
            }
          },
        },
        breakpoints: {
          768: {
            allowTouchMove: false,
          },
          0: {
            allowTouchMove: true,
          },
        },
      });
    }

    function startAutoSwitching() {
      clearInterval(autoSwitchTimer);

      autoSwitchTimer = setInterval(() => {
        currentIndex = (currentIndex + 1) % descriptionElements.length;
        if (swiperInstance1) changeTab(currentIndex, `#tabCardsSwiper-${sectionId}`, swiperInstance1);
        if (swiperInstance2) changeTab(currentIndex, `#motabCardsSwiper-${sectionId}`, swiperInstance2);
      }, swiperTime);
    }

    function handleResize() {
      if (swiperInstance1) resetProgressBars(`#tabCardsSwiper-${sectionId}`);
      if (swiperInstance2) resetProgressBars(`#motabCardsSwiper-${sectionId}`);

      changeTab(currentIndex, `#tabCardsSwiper-${sectionId}`, swiperInstance1);
      changeTab(currentIndex, `#motabCardsSwiper-${sectionId}`, swiperInstance2);
    }

    window.addEventListener("resize", handleResize);

    // 直接赋值到全局变量
    swiperInstance1 = initSwiper(`#tabCardsSwiper-${sectionId}`);
    swiperInstance2 = initSwiper(`#motabCardsSwiper-${sectionId}`);

    startAutoSwitching();
  })();
});
